<template>
	<div>
		<el-form :model="form" label-position="top" :rules="rules" ref="form">
			<el-form-item :label="stepTable.displayname+(stepTable.fieldtip?'('+stepTable.fieldtip+')':'')||''" prop="step">
				<!-- <tinymce-editor v-model="form.step" ref="editor"></tinymce-editor> -->
				<Editor v-model="form.step" :maxLength="stepTable.len" v-if="stepTable.placecontent"
					:placeholder="stepTable.placecontent || ''"
				></Editor>
				<!-- <el-input type="textarea" rows="6"  show-word-limit placeholder="写明每个时间节点、工作形式和内容以及每个时间节点的预期目标（含前期准备及线上工作）" v-model="form.step" maxlength="500">
        </el-input> -->
			</el-form-item>
			<yincan	:content="stepTable.inputtip"></yincan>
			<el-form-item :label="riskTable.displayname+(riskTable.fieldtip?'('+riskTable.fieldtip+')':'')||''" prop="risk">
				<Editor v-if="riskTable.placecontent" v-model="form.risk" ref="editor" :placeholder="riskTable.placecontent || ''" :maxLength="riskTable.len"></Editor>
				<!-- <el-input type="textarea" rows="6"  show-word-limit placeholder="请输入项目风险及应对措施" v-model="form.risk" maxlength="500">
        </el-input> -->
			</el-form-item>
			<yincan	:content="riskTable.inputtip"></yincan>
			<el-form-item :label="targetTable.displayname+(targetTable.fieldtip?'('+targetTable.fieldtip+')':'')||''" prop="target">
				<Editor v-if="targetTable.placecontent" v-model="form.target" ref="editor" :placeholder="targetTable.placecontent || ''" :maxLength="targetTable.len"></Editor>
				<!-- <el-input type="textarea" rows="6"  show-word-limit placeholder="请输入预期达到的目标,环保和社会效益,专利成果,论文等" v-model="form.target" maxlength="500">
        </el-input> -->
			</el-form-item>
			<yincan	:content="targetTable.inputtip"></yincan>
		</el-form>
		<bottomButtons @childrenDoPre="childrenDoPre" @childrenDoNext="childrenDoNext" />
	</div>
</template>
<script>
	import bottomButtons from "../../../components/bottomButtons.vue";
	import TinymceEditor from "../../../components/tinymce-editor.vue";
	import Editor from "@/components/Editor.vue"
	import yincan from "../../../components/yincan.vue";
	import {
		saveProject,
		getProjectType
	} from "../../../api/signUp";
	import res from "../../../utils/msg";
	export default {
		components: {
			bottomButtons,
			TinymceEditor,
			Editor,
			yincan
		},
		data() {
			return {
				typechoose: '',
				form: {
					iscg: 1,
					project_id: "", // 项目 id
					school: "", // 学校名称
					team: "", // 团队
					name: "", // 项目名称
					project_type_id: "", // 项目类型
					teacher: "", // 指导老师
					teacherphone: "", // 老师联系方式
					dutyperson: "", // 项目负责人
					dutypersonphone: "", // 项目负责人联系方式
					address: "", // 通讯地址
					introduce: "", // 项目简介
					innovate: "", // 项目创新点
					activitytime: "", // 活动时间
					activityaddress: "", // 活动地点
					activityobject: "", // 活动对象
					step: "", // 步骤
					risk: "", // 项目风险
					target: "", // 预期目标
				},
				cinum: 1,
				rules: {},
				stepTable:{},//步骤
				riskTable:{},//项目风险
				targetTable:{},//预期目标
			};
		},
		mounted() {
			this.gettype()
			setTimeout(() => {
				this.getLable()
			}, 1500);
		},
		watch: {
			'form.step': {
				handler(newval) {
					if (this.cinum == 2) {
						if (this.form?.step?.trim().length >= this.stepTable.len) {
							res.error("最多只能输入" + this.stepTable.len + "个字");
						}
					} else {
						this.cinum = 2
					}
				},
				deep: true,
				immediate: true
			},
			'form.risk': {
				handler(newval) {
					if (this.cinum == 2) {
						if (this.form?.risk?.trim().length >= this.riskTable.len) {
							res.error("最多只能输入" + this.riskTable.len + "个字");
						}
					} else {
						this.cinum = 2
					}
				},
				deep: true,
				immediate: true
			},
			'form.target': {
				handler(newval) {
					if (this.cinum == 2) {
						if (this.form?.target?.trim().length >= this.targetTable.len) {
							res.error("最多只能输入" + this.targetTable.len + "个字");
						}
					} else {
						this.cinum = 2
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			getLable(){
				this.stepTable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'step')
				this.riskTable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'risk')
				this.targetTable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'target')
			},
			gettype() {
				getProjectType().then(res => {
					this.typechoose = res.data.value
				})
			},
			getFather_step4(data) {
				this.form = data;
			},
			childrenDoPre() {
				this.$parent.doPre();
			},
			childrenDoNext() {
				if (!this.form.step) {
					this.$message({
						message: '推进步骤',
						type: 'warning'
					});
					return
				}
				if (!this.form.risk) {
					this.$message({
						message: '项目风险及对应措施',
						type: 'warning'
					});
					return
				}
				if (!this.form.target) {
					this.$message({
						message: '预期达到的目标',
						type: 'warning'
					});
					return
				}
				const _this = this;
				_this.$refs.form.validate(async (valid) => {
					if (valid) {
						let _data = {
							...this.form,
							project_id: _this.form.project_id||_this.form.id,
						};
						// 把 project_type_id 转为逗号分隔的字符串
						if (this.typechoose == 1) {
							let newProjectTypeStrs = "";
							for (const v of _data.project_type_ids) {
								newProjectTypeStrs += v + ",";
							}
							newProjectTypeStrs = newProjectTypeStrs.substring(
								0,
								newProjectTypeStrs.length - 1
							);
							_data.project_type_ids = newProjectTypeStrs;
						}
						try {
							let saveRes = await saveProject(_data);
							if (saveRes.data.code == 1) {
								this.$message.success('更新成功');
								_this.$parent.doNext();
							} else {
								this.$message.error(saveRes.data.msg);
							}
						} catch (error) {
							console.log(error);
						}
					}
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.fz-FF0000 {
		color: #ff0000;
		font-size: 14px;
	}
</style>